import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.math.Vector2

class Point (
    var pos: Vector2 = Vector2(),
    var col: Color = Color(0.0),
    var pigment: Color = Color(1.0),
    var on: Boolean = false,
    var brightness: Double = 0.0
)
